import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import useMedia from '../../../../../hooks/useMedia';
import useOnClickOutside from '../../../../../hooks/useOnClickOutside';
import { getPrice } from '@/utils/helper';
import AddSwatchToCartButton from '../sidebar/fabricDescription/AddSwatchToCartButton';
import Fabrics from './Fabrics';
import ImageSliderFabric from './ImageSliderFabric';
import Icon from '../../../../../common/Icon';
import {getFilteredFabrics} from "@/common/QuickShip";

const Wrapper = styled.div`
  width: 420px;
  right: 0;
  background: white;
  position: fixed;
  top: 0;
  z-index: 1010;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;

  .head-container {
    border: 1px solid #d8d8d8;
    padding: 20px;
    .show-filter-text {
      cursor: pointer;
      width: 110px;
      text-align: left;
    }
  }
  .show-filter-text {
    cursor: pointer;
    width: 110px;
    text-align: left;
  }

  .in-stock-only {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      margin-left: 6px;
    }
  }

  .body-container {
    border-left: 1px solid #d8d8d8;
    overflow-y: scroll;
    height: 78vh;

    .filter-clear-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .filters-container {
      margin-top: 20px;
      padding: 0 20px;
      .filter-text-arrow {
        cursor: pointer;
        display: flex;
        align-items: baseline;
        img {
          width: 16px;
          height: auto;
          margin-left: 00px;
        }
      }
    }
  }

  .footer-container {
    border: 1px solid #d8d8d8;
    padding: 10px 20px 30px 20px;
    .selected {
      margin: 15px 0;
      text-align: start;
    }
    .buttons-container {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
    }
  }

  .show-filters-toggle-stock {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .ruler {
    color: #ddd;
  }

  .fabric-details-link {
    color: #2A5CAF;
    text-decoration: underline;
    margin-bottom: 20px;
    display: block;
  }

  .add-swatch-btn {
    margin-top: 2px;

    button {
      width: 100%;
    }
  }

  .order-swatches {
    margin: 30px;
    text-align: right;
  }

  .fabric-selector-label {
    margin: 28px 34px 20px;
    opacity: 0.9;
    font-family: 'AT Surt';
    font-size: 13px;
    font-weight: bold;
    color: #7b7b7b;
    text-transform: uppercase;
  }

  .stock-only-clear-all-container {
    .clear-all {
      cursor: pointer;
      text-align: end;
      margin-top: 15px;
    }
  }

  .filter-btn-stock-only {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    padding: 0 15px;
    margin-top: 20px;
  }

  @media (max-width: 992px) {
    width: 100%;
    top: 0;
    height: calc(100% - 0px);

    .footer-container {
      margin-top: 0;
      .buttons-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
      }
      .selected {
        margin-top: 0;
      }
    }
  }
`;

function FabricSidebar({
  handleShowFabric,
  open,
  setHoveredFabric,
  sliderImages,
  setSelectedFabric,
  selectedFabric,
  setProductVar,
  productData,
  loading: loadingImages,
  setChangeFeaturedFabrics,
  setViewDetails,
  viewDetails,
  isImageHovered,
  shippingFilter,
  pdpFabrics = {
    preferred_pdp_fabrics: [],
    non_preferred_pdp_fabrics: [],
  }
}) {
  const {
    preferred_pdp_fabrics,
    non_preferred_pdp_fabrics
  } = pdpFabrics;

  // Yep, filtering again here... :-(
  const filteredPreferredFabrics = getFilteredFabrics(
    shippingFilter,
    non_preferred_pdp_fabrics,
    productData
  );

  const fabricSidebarRef = useRef(null);

  useOnClickOutside(fabricSidebarRef, () => {
    if (open && !viewDetails && !isImageHovered) {
      handleShowFabric(selectedFabric);
    }
  });

  const isMobile = isItMobile();

  useEffect(() => {
    setSelectedFabric(productData.fabric);
  }, [productData.fabric.id]);

  const handleProductVar = fabricId => {
    setChangeFeaturedFabrics(true);
    setProductVar({
      fabric_id: fabricId,
      frame_id: productData.frame.id,
      ...(productData.frame.size !== null && {
        size_id: productData.frame.size.id
      }),
      ...(productData.frame.firmness && {
        firmness_id: productData.frame.firmness.id
      }),
      //render property / value if the leg is not null
      ...(productData.leg !== null && {
        leg_id: productData.leg.id
      }),
      ...(productData.casterLeg && {
        caster_leg_id: productData.casterLeg.id
      }),
      ...(productData.frame.orientation !== null && {
        orientation: productData.frame.orientation
      }),
      ...(productData.frame.has_assembly_options && {
        is_assembled: productData.is_assembled
      }),
      ...(productData.frame.has_set_of_two && {
        supplier_quantity: productData.supplier_quantity
      }),
      ...(productData.frame.has_wallpaper_types && {
        wallpaper_type: productData.wallpaper_type
      })
    });
  };

  if (loadingImages) return <div>'Loading fabrics...'</div>;

  return (
    <Wrapper open={open} ref={fabricSidebarRef}>
      <div className="head-container">
        <BackText onClick={handleShowFabric}>
          &lt; Back
        </BackText>
        <Title>Select Fabric</Title>
      </div>
      {isMobile && (
        <ImageSliderFabric
          className="hide-on-desktop"
          loading={loadingImages}
          sliderImages={sliderImages}
          productData={productData}
        />
      )}
      <div className="body-container">

        { !!preferred_pdp_fabrics?.length && (
          <>
            <p className="fabric-selector-label">
              designer recommendations
            </p>

            <Fabrics
              handleProductVar={handleProductVar}
              selectedFabric={selectedFabric}
              setSelectedFabric={setSelectedFabric}
              fabrics={preferred_pdp_fabrics}
              setHoveredFabric={setHoveredFabric}
            />

            <hr className="ruler" />

            <p className="fabric-selector-label">
              more custom fabrics
            </p>
          </>
        )}

        <Fabrics
          handleProductVar={handleProductVar}
          selectedFabric={selectedFabric}
          setSelectedFabric={setSelectedFabric}
          fabrics={filteredPreferredFabrics}
          setHoveredFabric={setHoveredFabric}
        />

        <div className="order-swatches">
          <a href="/fabric-swatches">
            Order Swatches
            <Icon icon="ti-new-tab" size={20} color="#2A5CAF" />
          </a>
        </div>
      </div>
      <div className="footer-container">
        <Text className="selected">
          Selected: {selectedFabric.id && selectedFabric.name}
          {selectedFabric.id &&
            selectedFabric.collaborator &&
            ` by ${selectedFabric.collaborator.name}`}
          {', '}${getPrice(productData.price)}
        </Text>

        {isMobile && (
          <a
            onClick={() => { setViewDetails(true) }}
            className="fabric-details-link"
          >
            Fabric Details
          </a>
        )}

        <div className="buttons-container">
          <Button
            onClick={() => {
              handleShowFabric(selectedFabric);
            }}
          >
            Continue
          </Button>
          <AddSwatchToCartButton
            className="add-swatch-btn"
            productData={productData}
          />
        </div>
      </div>
    </Wrapper>
  );
}

export default FabricSidebar;


function isItMobile() {
    return typeof window !== `undefined`
      ? useMedia('(max-width: 992px) ')
      : null;
}

const BackText = styled.div`
  cursor: pointer;

  position: absolute;
  left: 10px;
  top: 17px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  color: #6c6c6c;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const Title = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  @media (max-width: 992px) {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;

    color: ${({ theme }) => theme.colors.charcoal};
  }
`;

const Text = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;

    letter-spacing: 0.04em;
  }
`;

const Button = styled.button`
  background: ${({ theme, light }) => (!theme.old ? theme.buttons.primary.backgroundColor : light ? 'white' : 'black')};
  color: ${({ theme, light }) => (!theme.old ? theme.buttons.primary.color : light ? 'black' : 'white')};
  border: ${({ theme }) => theme.old ? '1px solid black' : 'none'};
  border-radius: ${({ theme }) => theme.old ? 'none' : '30px'};
  height: 50px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  /* identical to box height, or 144% */

  letter-spacing: 0.04em;

  opacity: 0.9;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;
    height: 45px;
    letter-spacing: 0.04em;
  }
`;
